import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Button from "../../../components/Button/Button";
import Layout from "../../../components/Accounts/Layout";
import { ResendCodeContainer } from "../../../components/Accounts/OtpInputField";
import { TransferTitleSubTitle } from ".";
import { styled } from "styled-components";
import {
  OtpFormContainer,
  OtpInputContainer,
  OtpInput,
  ResendCodeText,
} from "../../../pages/Otp/otp.styles";
import { formatTime } from "../../../utils/formatTimeAndDate";

interface OTPPageProps {
  handleOtpSubmit?: () => void;
  otpValues: string[];
  setOtpValues: (values: string[]) => void;
  handleResendOtp: () => void;
}

const OtpPage: React.FC<OTPPageProps> = ({
  handleOtpSubmit,
  setOtpValues,
  otpValues,
  handleResendOtp,
}) => {
  const [timerCount, setTimerCount] = useState(56);
  const [disable, setDisable] = useState(false);

  const otpInputs = useRef<HTMLInputElement[]>([]);

  const handleOtpChange = (index: number, value: string) => {
    const newValue = value.charAt(0);
    const updatedOtpValues = [...otpValues];
    updatedOtpValues[index] = newValue;
    setOtpValues(updatedOtpValues);
    if (newValue && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    } else if (!newValue && index > 0) {
      otpInputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && index > 0 && !otpValues[index]) {
      event.preventDefault();
      const updatedOtpValues = [...otpValues];
      updatedOtpValues[index - 1] = "";
      setOtpValues(updatedOtpValues);
      otpInputs.current[index - 1].focus();
    }
  };

  const isFormValid = () => {
    return otpValues.every((value) => value !== "");
  };
  useEffect(() => {
    let interval: any = null;
    if (disable) {
      interval = setInterval(() => {
        setTimerCount((lastTimerCount) => {
          if (lastTimerCount <= 1) {
            clearInterval(interval);
            setDisable(false);
          }
          return lastTimerCount - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [disable]);
  return (
    <Layout>
      <Wrapper>
        <TransferTitleSubTitle>
          Enter the 6-digit code sent to your email to confirm payment
        </TransferTitleSubTitle>
        <OtpFormContainer>
          <OtpInputContainer className="otpInput">
            {otpValues.map((value, index) => (
              <OtpInput
                key={index}
                value={value}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleOtpChange(index, e.target.value)
                }
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
                  handleKeyDown(index, e)
                }
                type="text"
                maxLength={1}
                ref={(ref) => {
                  if (ref) {
                    otpInputs.current[index] = ref;
                  }
                }}
              />
            ))}
          </OtpInputContainer>
        </OtpFormContainer>
        <ResendCodeContainer>
          <ResendCodeText onClick={handleResendOtp}>
            Resend code ({formatTime(timerCount)})
          </ResendCodeText>
        </ResendCodeContainer>
      </Wrapper>
      <Button
        id={""}
        type="button"
        onClick={handleOtpSubmit}
        padding={"10px 45%"}
        title={"Confirm"}
        border="10px"
        green
        disabled={!isFormValid()}
      />
    </Layout>
  );
};

export default OtpPage;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: center;
`;
